import axios from 'axios';
const token = localStorage.getItem('auth_token'); 
export default axios.create({
  //baseURL: 'https://yourfriendmyfriend.ie/yfmf_admin/api/v1/',
  baseURL: 'https://yfmfstaging.jditechnology.net/yfmf_admin/api/v1/',
  timeout: 500000,
  headers: {
      "Content-Type": "multipart/form-data",
      'Authorization': `Bearer ${token}`
  }
});